"use client";

import React, { useCallback, useEffect, useState } from "react";
import BreadcrumbComp from "../shared/BreadcrumbComp";
import { Pagination } from "antd";
import Link from "next/link";
import { AiOutlineClockCircle } from "react-icons/ai";
import ReactParser from "html-react-parser";
import dayjs from "dayjs";
import useFetchApi from "@/hooks/useFetchApi";

const RecruitmentItem = ({ item }) => {
  return (
    <Link href={`/tuyen-dung/${item.id}`}>
      <div className="flex group flex-col md:flex-row gap-6 bg-[#FAFAFA] overflow-hidden transition-shadow cursor-pointer">
        <div className="w-full md:w-[280px] h-[180px] shrink-0 overflow-hidden">
          <img
            src={item.thumbnail}
            alt={item.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
        </div>
        <div className="flex flex-col flex-1 p-2">
          <div className="flex items-center text-[#585858] text-sm mb-2 gap-2">
            <AiOutlineClockCircle color="#585858" />
            {dayjs(item.activedAt || item.createdAt).format("DD/MM/YYYY")}
            {item.expired
              ? ` - ${dayjs(item.expired).format("DD/MM/YYYY")}`
              : ""}
          </div>
          <h3 className="text-lg font-bold text-[#1A1A1A] mb-2 leading-tight group-hover:text-[#E5C383]">
            {item.title}
          </h3>
          <div className="text-[#585858] text-sm text-justify line-clamp-3 mb-3 leading-relaxed">
            {ReactParser(item.content)}
          </div>
          <div className="flex items-center text-[#06B6D4] text-sm font-semibold hover:opacity-80 mt-auto">
            Tìm hiểu thêm
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-3 h-3 ml-1"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
              />
            </svg>
          </div>
        </div>
      </div>
    </Link>
  );
};

const RecruitmentIndex = ({
  recruitments: dataRecruitments,
  pagination: dataPagination,
}) => {
  const [recruitments, setRecruitments] = useState(dataRecruitments || []);
  const [pagination, setPagination] = useState(dataPagination || {});
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isFisrstLoad, setIsFirstLoad] = useState(true);

  const {
    data,
    errors,
    triggerFetch: loadMoreList,
  } = useFetchApi({
    url: "/recruitments",
    params: {
      page: page,
    },
    skip: true,
  });

  useEffect(() => {
    console.log(data);
    if (!isFisrstLoad) {
      setRecruitments(data?.data?.recruitments || []);
      setPagination(data?.data?.pagination || {});
      setLoading(false);
    }
  }, [data]);

  useEffect(() => {
    setIsFirstLoad(false);
  }, [dataPagination]);

  useEffect(() => {
    if (!isFisrstLoad) {
      loadMoreList();
    }
  }, [page]);

  const loadMore = useCallback((p) => {
    setLoading(true);
    setPage(p);
  }, []);
  const breadcrumbItems = [
    { title: "Trang Chủ", href: "/" },
    { title: "Tuyển Dụng", href: "/tuyen-dung" },
  ];

  const [currentPage, setCurrentPage] = useState(pagination?.page);

  return (
    <div className="bg-white pb-10">
      <div className="section mx-auto px-4 lg:px-0">
        <BreadcrumbComp items={breadcrumbItems} />
        <div className="py-8">
          <h1 className="text-3xl md:text-4xl font-bold text-center text-black mb-10">
            Tuyển Dụng
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">
            {recruitments.map((item) => (
              <RecruitmentItem item={item} />
            ))}
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center border-t border-gray-200 pt-6">
            <div className="text-[#555555] text-sm mb-4 md:mb-0">
              Tổng {pagination?.total}
            </div>
            <Pagination
              current={pagination.page}
              onChange={loadMore}
              total={pagination.total}
              showSizeChanger={false}
              pageSize={pagination?.perPage || 10}
              className="custom-pagination"
            />
          </div>
        </div>
      </div>
      <style jsx global>{`
        .custom-pagination .ant-pagination-item-active {
          border-color: #e5c383;
          background: #e5c383;
        }
        .custom-pagination .ant-pagination-item-active a {
          color: white !important;
        }
        .custom-pagination .ant-pagination-item:hover {
          border-color: #e5c383;
        }
        .custom-pagination .ant-pagination-item:hover a {
          color: #e5c383;
        }
      `}</style>
    </div>
  );
};

export default RecruitmentIndex;
